import { X } from 'lucide-react';

export function MobileWizard({ title, text, actionLabel, onAction, onClose }: { title: string; text: string; actionLabel: string; onAction: () => void; onClose: () => void }) {
  return (
    <div className="mobile-modal-backdrop" role="presentation" onClick={onClose}>
      <section className="mobile-wizard" role="dialog" aria-modal="true" aria-label={title} onClick={(event) => event.stopPropagation()}>
        <div className="mobile-action-head">
          <strong>{title}</strong>
          <button type="button" onClick={onClose} aria-label="Close"><X size={19} /></button>
        </div>
        <p>{text}</p>
        <div className="mobile-wizard-steps">
          <span>1</span>
          <span>2</span>
          <span>3</span>
        </div>
        <button
          type="button"
          className="theme-btn-primary"
          onClick={() => {
            onClose();
            onAction();
          }}
        >
          {actionLabel}
        </button>
      </section>
    </div>
  );
}
